import { z } from "zod"

export const intervalSchema = z.object({
  quantityAmount: z.number(),
  rateAmount: z.number().nullable(),
  costAmount: z.number().optional(),
})

export type Interval = z.infer<typeof intervalSchema>
